import React from 'react'
import './App.css'
import Routes from './routes'
import { BrowserRouter as Router } from 'react-router-dom'
import { setAuthToken } from './common/api'
import { CookiesProvider } from 'react-cookie'
import AuthState from './context/auth/authState'
import CommonState from './context/common/commonState'
import UserState from './context/user/userState'
import AlertState from './context/alert/alertState'
import ProductState from './context/product/productState'
import AuctionState from './context/auction/auctionState'
import CartState from './context/cart/cartState'
import BuyerState from './context/buyer/buyerState'
import AutopltState from './context/autopilot/autopltState'
import PayState from './context/payment/payState'
import LoaderState from './context/loaders/loader.state'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import { SnackbarProvider } from 'notistack'
import Alerts from './common/alert'

global.site_url = process.env.REACT_APP_DOMAIN
global.images_url = global.site_url + '/uploads/product/compressed/'
global.site_id = process.env.REACT_APP_SITE_ID ? process.env.REACT_APP_SITE_ID : 1
global.site_title = process.env.SITE_TITLE ? process.env.SITE_TITLE : 'LedMax'
global.maintainance_mode = false

if (localStorage.token) {
    setAuthToken(localStorage.token)
}

const App = () => {
    return (
        <CookiesProvider>
            <LoaderState>
                <CommonState>
                    <AuthState>
                        <AlertState>
                            <UserState>
                                <ProductState>
                                    <AuctionState>
                                        <CartState>
                                            <PayState>
                                                <BuyerState>
                                                    <AutopltState>
                                                        <MuiPickersUtilsProvider
                                                            utils={MomentUtils}
                                                        >
                                                            <SnackbarProvider maxSnack={1}>
                                                                <div className="App">
                                                                    <Alerts />
                                                                    <Router>
                                                                        <Routes />
                                                                    </Router>
                                                                    <a
                                                                        className="whatsappFloatBtn"
                                                                        href="https://api.whatsapp.com/send/?phone=%2B40746222569&text&type=phone_number&app_absent=0"
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        aria-label="Contact us on WhatsApp"
                                                                        title="Contact us on WhatsApp"
                                                                        onClick={(e) =>
                                                                            e.currentTarget.blur()
                                                                        }
                                                                    >
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            viewBox="0 0 32 32"
                                                                            width="32"
                                                                            height="32"
                                                                            fill="#fff"
                                                                            aria-hidden="true"
                                                                            focusable="false"
                                                                        >
                                                                            <path d="M16.001 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.257.592 4.463 1.716 6.406L3.2 28.8l6.55-1.716a12.74 12.74 0 006.251 1.632h.005c7.06 0 12.8-5.74 12.8-12.8s-5.74-12.716-12.8-12.716zm0 23.36h-.004a10.6 10.6 0 01-5.4-1.48l-.387-.23-4.006 1.05 1.07-3.905-.252-.4a10.56 10.56 0 01-1.62-5.635c0-5.86 4.77-10.63 10.634-10.63 2.84 0 5.51 1.107 7.52 3.117a10.56 10.56 0 013.113 7.52c0 5.86-4.77 10.63-10.664 10.63zm5.833-7.96c-.32-.16-1.892-.933-2.185-1.04-.293-.107-.507-.16-.72.16-.213.32-.826 1.04-1.013 1.253-.187.213-.373.24-.693.08-.32-.16-1.35-.498-2.573-1.588-.95-.848-1.592-1.895-1.779-2.215-.187-.32-.02-.493.14-.652.144-.143.32-.373.48-.56.16-.187.213-.32.32-.533.107-.213.053-.4-.027-.56-.08-.16-.72-1.735-.986-2.375-.26-.624-.524-.54-.72-.55l-.613-.011c-.213 0-.56.08-.853.4-.293.32-1.12 1.093-1.12 2.667 0 1.573 1.147 3.093 1.307 3.307.16.213 2.257 3.447 5.467 4.833.764.33 1.36.527 1.825.674.767.244 1.464.21 2.016.127.615-.092 1.892-.773 2.159-1.52.267-.747.267-1.387.187-1.52-.08-.133-.293-.213-.613-.373z" />
                                                                        </svg>
                                                                        <span className="whatsappFloatLabel">
                                                                            Contact us on WhatsApp
                                                                        </span>
                                                                    </a>
                                                                </div>
                                                            </SnackbarProvider>
                                                        </MuiPickersUtilsProvider>
                                                    </AutopltState>
                                                </BuyerState>
                                            </PayState>
                                        </CartState>
                                    </AuctionState>
                                </ProductState>
                            </UserState>
                        </AlertState>
                    </AuthState>
                </CommonState>
            </LoaderState>
        </CookiesProvider>
    )
}

export default App
